module.exports = __webpack_public_path__ + "img/Next.4b16d05b.svg";